import customAxios from "./axiosConfig";

const PromoBannerService = {
  list (params = {}) {
    const api_url = window.Urls['promo-banner-list']()
    return customAxios.get(api_url, { params })
  }
}

export default PromoBannerService;
